import { render, staticRenderFns } from "./LinkedButton.vue?vue&type=template&id=2a341c7c&"
import script from "./LinkedButton.vue?vue&type=script&lang=js&"
export * from "./LinkedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports